import React, { createElement } from 'react';
// Define types for Facebook Pixel
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    fbevents: any;
    FB_PIXEL_INITIALIZED: boolean;
  }
}
// Facebook Pixel ID
const PIXEL_ID = '2524710364576107';
/**
 * Simplified Facebook Pixel initialization - no duplicates, no retries
 */
export const initFacebookPixel = () => {
  return new Promise<boolean>(resolve => {
    try {
      console.log('🔍 Starting Facebook Pixel initialization with ID:', PIXEL_ID);
      // Skip if window is not available (SSR)
      if (typeof window === 'undefined') {
        console.log('❌ Window not available, skipping pixel initialization');
        resolve(false);
        return;
      }
      // If fbq already exists and is a function, resolve immediately
      if (typeof window.fbq === 'function') {
        console.log('✅ fbq already exists, using existing implementation');
        window.FB_PIXEL_INITIALIZED = true;
        resolve(true);
        return;
      }
      // Check if script already exists in DOM to prevent duplication
      if (document.getElementById('facebook-pixel-script')) {
        console.log('⚠️ Facebook Pixel script already exists in DOM, not adding another one');
        resolve(false);
        return;
      }
      // Create a simple script element - ONCE
      const script = document.createElement('script');
      script.id = 'facebook-pixel-script';
      script.innerHTML = `
        !function(f,b,e,v,n,t,s) {
          if(f.fbq)return;
          n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;
          n.push=n;
          n.loaded=!0;
          n.version='2.0';
          n.queue=[];
          t=b.createElement(e);
          t.async=!0;
          t.src=v;
          s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)
        }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${PIXEL_ID}');
        fbq('track', 'PageView');
      `;
      // Add the script to the head
      document.head.appendChild(script);
      // Simple noscript tag - no dynamic image beacons elsewhere
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `
        <img height="1" width="1" style="display:none" 
          src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" alt="" />
      `;
      document.body.appendChild(noscript);
      // Mark as initialized and resolve
      window.FB_PIXEL_INITIALIZED = true;
      resolve(true);
    } catch (error) {
      console.error('❌ Error during Facebook Pixel initialization:', error);
      resolve(false);
    }
  });
};
// Meta Pixel NoScript tag component - simple, static
export const MetaPixelNoScript = () => {
  return <noscript data-id="element-550">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-551" />
    </noscript>;
};
// Debug function - simplified, no sending test events
export const debugPixelStatus = () => {
  if (typeof window === 'undefined') {
    return {
      available: false,
      reason: 'Window not available'
    };
  }
  const pixelAvailable = typeof window.fbq === 'function';
  const fbqType = typeof window.fbq;
  const pixelInitialized = window.FB_PIXEL_INITIALIZED || false;
  console.log(`
    🔍 Facebook Pixel Debug:
    - Pixel ID: ${PIXEL_ID}
    - Pixel function exists: ${pixelAvailable}
    - Type of fbq: ${fbqType}
    - Pixel explicitly initialized: ${pixelInitialized}
  `);
  return {
    available: pixelAvailable,
    type: fbqType,
    initialized: pixelInitialized
  };
};
export default {
  init: initFacebookPixel,
  NoScript: MetaPixelNoScript,
  debug: debugPixelStatus
};